import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRotateLeftVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={174}
    height={311}
    fill="none"
    {...props}
  >
    <path
      stroke="#EEEFFF"
      strokeWidth={3}
      d="M135.999 214.5c-3.167 6.167-13.794 28.6-9.394 45s15.833 38.833 21 48zm0 0-9.394-57.5M27.5 307.5c-1.954-8.632 1.73-43.867.5-58-1.088-12.5-6.605-79.557-7-92.5m149.999 148.5 1.106-98.5c-4.419-52.891-3.105-83.704-11.5-90-7.034-5.275-18.995-8.908-31-12.852-6.202-2.216-20.305-7.623-27.105-11.526-3.913-2.595-7.025-5.578-8.895-9.122-9.5-18 6.5-13 5-42S82.605 2 63.105 2c-20.5 0-40 13-43 29-2.4 12.8-2.667 20.333-2.5 22.5 1.167.833 3.5 3 3.5 5 0 2.5-5.5 13-4.5 16.5s6.5 1.5 7.5 3-.5 4 1 5.5 5 0 5.5 1.5-3 3-1.5 5 4.5 1 5.5 2.5-1.5 3 1.5 7 10.5-.5 16 3.5c4.4 3.2 2.394 3-5.106 4.5-10 1.5-25 3-32.5 7-3.334 1.779-7.69 10.642-8.5 15.5C5.5 133 2 222 2 227c.5 33 2.5 20 5.5 83"
    />
  </svg>
);
export default SvgRotateLeftVector;
